export default "__VITE_ASSET__CREkwsEv__"